var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEye = function SvgEye(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      width: 22,
      height: 21
    },
    viewBox: "0 0 22 21"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#3E73A4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "m2 1.525 3.59 3.59M20 19.524l-3.589-3.589m-3.536 1.414q-.912.174-1.874.175c-4.478 0-8.268-2.943-9.543-7a10 10 0 0 1 1.563-3.029m5.858.908a3 3 0 1 1 4.243 4.243M8.878 8.403l4.242 4.242M8.88 8.404l-3.29-3.29m7.532 7.532L5.59 5.114m7.532 7.532 3.29 3.29M5.59 5.114A9.95 9.95 0 0 1 11 3.525c4.478 0 8.268 2.943 9.543 7a10.03 10.03 0 0 1-4.132 5.411"
  })));
};
export default SvgEye;